/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { createContextableRoute } from '@gh/common-internal-shared';

import { createRoute } from '@gh/common-shared';
import { CoreLazyModule, LAZY_SYMBOLS, lazyActivatorRoute } from '@gh/core-lazy';
import { CONTACT_DETAILS_CONTEXT_ROUTE, contactDetailsDialogRoute } from './contact-details';

import { ContactListBusinessService, ContactListComponent } from './contact-list';

export const routes = [
  lazyActivatorRoute,
  createRoute({
    path: '',
    component: ContactListComponent,
    init: ContactListBusinessService,
    auth: {
      permission: 'Contacts.Details.ANY',
    },
  }),
  createContextableRoute({
    path: 'new',
    auth: {
      permission: [
        'Contacts.Details.CREATE_EDIT',
      ],
    },
    contextRoute: CONTACT_DETAILS_CONTEXT_ROUTE,
  }),
  createContextableRoute({
    path: ':contactId',
    auth: {
      permission: [
        'Contacts.Details.VIEW',
        'Contacts.Details.CREATE_EDIT',
      ],
    },
    contextRoute: CONTACT_DETAILS_CONTEXT_ROUTE,
  }),
];

export function contactsLazySymbolsFactory(): Hash<any> {
  return { contactDetailsDialogRoute };
}

@NgModule({
  imports: [
    CoreLazyModule.forChild(),
    RouterModule.forChild(routes),
  ],
  declarations: [],
  providers: [
    { provide: LAZY_SYMBOLS, useFactory: contactsLazySymbolsFactory, deps: [] },
  ],
  exports: [RouterModule],
})
export class BuilderContactsRoutingModule {
}
